/*jslint browser: true, fudge: true, long: true */
/* eslint-env browser */
/*global blacksunplc, jQuery, window, Waypoint */

(function ($) {
    "use strict";

    var numbers = blacksunplc.numbers; // import * as numbers   from "module:blacksunplc/numbers"
    var arrays = blacksunplc.arrays; // import * as arrays    from "module:blacksunplc/arrays"
    var functions = blacksunplc.functions; // import * as functions from "module:blacksunplc/functions"
    var analytics = blacksunplc.analytics; // import * as analytics from "module:blacksunplc/analytics"
    var security = blacksunplc.security; // import * as security  from "module:blacksunplc/security"
    var events = blacksunplc.events; // import * as events    from "module:blacksunplc/events"
    var jsonml = blacksunplc.jsonml; // import * as jsonml    from "module:blacksunplc/jsonml"

    events.ready(function () {

        var pathName = window.location.pathname;

        if (security.antiClickJack()) {
            return;
        }

        analytics.prepareOpenExts();
        analytics.installListener();

        var windowWidth;
        var windowHeight;

        function setHeightOfIntroSection() {
            var $intro = $("section.introduction");
            if (windowWidth / windowHeight < 2.2) {
                var paddingTop = $("body").css("padding-top");
                var headerOuterHeight = /** @type {number} */ $("header").outerHeight();
                var heightOffset = 2 * numbers.parseInt(paddingTop, 10) + numbers.trunc(headerOuterHeight);
                $intro.css("height", "calc(100vh - " + heightOffset + "px)");
                $intro.removeClass("overflow");
            } else {
                $intro.addClass("overflow");
            }
        }

        function measureWindow() {
            var $window = $(window);
            windowWidth = $window.width();
            windowHeight = $window.height();
            if (!$(".viewport-test").length) {
                return;
            }
            $(".viewport-test .width span").html(windowWidth);
            $(".viewport-test .height span").html(windowHeight);
        }


        function animateElement(element) {
            var $element = $(element);
            if (!$element.hasClass("animated")) {
                $element.addClass("animated");
            }
        }

        function animateAllElements() {
            $(".animate, .animate-on-load").each(function (ignore, element) {
                animateElement(element);
            });
        }

        function animate() {
            if (windowWidth <= 979) {
                animateAllElements();
            } else {
                var $document = $(window.document);
                var $window = $(window);
                $(".animate").each(function (ignore, element) {
                    if ($document.scrollTop() + $window.height() / 1.25 > $(element).offset().top) {
                        animateElement(element);
                    }
                });
                $(".animate-on-load").each(function (ignore, element) {
                    animateElement(element);
                });
            }
        }

        function highlightNavItem() {
            var thisPage = $("body").attr("id").split("-page")[0];
            $("nav li").each(function (ignore, element) {
                var $element = $(element);
                var title = $element.attr("id");
                if (thisPage === title) {
                    $element.addClass("active");
                    $element.find("a").removeAttr("href");
                    return;
                }
            });
        }

        function toggleMenu() {
            $(".hamburger").on("click", function (event) {
                var $target = $(event.currentTarget);
                var $nav = $("nav");
                if ($nav.hasClass("active")) {
                    $nav.removeClass("active");
                    $target.removeClass("active");
                    return;
                }
                $nav.addClass("active");
                $target.addClass("active");
            });
        }

        function triggerMenu() {
            if (!$("nav").hasClass("active")) {
                return;
            }
            $(".hamburger")[0].click();
        }

        function wrapWords() {
            $("h1.words, h2.words").each(function (ignore, header) {
                var words = $(header).text().split(" ");
                var wrapped = arrays.map(words, function (word) {
                    return ["span", ["span", word], "\u00A0"]; // Unicode 00A0 is a non-breaking-space.
                });
                jsonml.inner(header, [""].concat(wrapped));
            });
        }

        var openedBox;

        function openHighlightBox() {
            $(".has-data .performance_boxes_box_text, .has-data .performance_boxes_box_text_span")
                .on("click", function (event) {
                    var $target = $(event.target);
                    if ($target.closest(".clearfix").hasClass("performance-boxes-static")) {
                        event.preventDefault();
                        event.stopPropagation();
                        return;
                    }
                    $(".performance_boxes .content").removeClass("active");
                    openedBox = $target.closest(".performance_boxes_box").find(".content");
                    openedBox.addClass("active");
                    $("html, body").animate({
                        "scrollTop": openedBox.offset().top - 80
                    }, 500);
                });
        }
        function closeHighlightBoxes() {
            $(".content").on("click", function (event) {
                $(event.delegateTarget).removeClass("active");
            });
        }

        function subnavLinks() {
            $(".subnav button").on("click", function (event) {
                var $target = $(event.currentTarget);
                var subnavTitle = $target.data("subnav");
                $(".subpage, .subnav button").removeClass("active");
                $(".subpage." + $target.attr("class")).addClass("active");
                $target.addClass("active");
                window.location.hash = subnavTitle;
            });
        }

        function setHashLocationSubnav() {
            var subnavToActivate;
            if (!window.location.hash) {
                if ($("body").attr("id") !== "strategic-agenda-page") {
                    return;
                }
                subnavToActivate = document.querySelector(".subnav ul li button");
            } else {
                var locationHash = security.safeLocationHash().substring(1);
                subnavToActivate = $(".subnav ul li button[data-subnav='" + locationHash + "']");
            }
            subnavToActivate.click();
        }

        function stakeholderSubnavDetection() {
            var stakeholderSections = document.getElementsByClassName("subpage");
            var i = 0;
            while (i < stakeholderSections.length) {
                new Waypoint({
                    "element": stakeholderSections[i],
                    "handler": function(direction) {
                        if (direction === "down") {
                            var location = pathName + "#" + this.element.getAttribute("data-section");
                            setTimeout(function () {
                                history.pushState(null, document.title, location);
                            }, 501);
                        }
                    },
                    "offset": "25%"
                });
                new Waypoint({
                    "element": stakeholderSections[i],
                    "handler": function(direction) {
                        if (direction === "up") {
                            var previousSection = this.previous();
                            var location = pathName + "#" + previousSection.element.getAttribute("data-section");
                            setTimeout(function () {
                                history.pushState(null, document.title, location);
                            }, 501);
                        }
                    },
                    "offset": "80%"
                });
                i += 1;
            }
        }

        function scrollToSection() {
            $(".subnav.stakeholder button").on("click", function (event) {
                var $target = $(event.target);
                $(".subnav.stakeholder button").removeClass("active");
                $target.addClass("active");
                var sectionName = $target.attr("id");
                var $section = $("article." + sectionName);
                var margin = $("hr,border.top").outerHeight();
                $("html, body").animate({
                    "scrollTop": $section.offset().top - margin
                }, 500);
            });
        }

        function resetScrollToSection() {
            var $clients = $("article.clients");
            if ($clients.length !== 0) {
                var scrollTrigger = $clients.offset().top;
                if ($(window.document).scrollTop() < scrollTrigger) {
                    $(".subnav.stakeholder button").removeClass("active");
                }
            }
        }

        function openShare() {
            $(".share").on("click", function () {
                $(".share-wrapper").addClass("active");
            });
        }

        function closeShare() {
            $(".share-wrapper .close").on("click", function () {
                $(".share-wrapper").removeClass("active");
            });
        }

        function equalHeightsGrouRevenues() {
            var $revenues = $(".group-revenues > ul > li div");
            if (!$revenues.length) {
                return;
            }
            windowWidth = $(window).width();
            if (windowWidth < 1024) {
                $revenues.css({
                    "height": "auto"
                });
                return;
            }
            var tallest = 0;
            $revenues.each(function (ignore, revenue) {
                if ($(revenue).outerHeight() > tallest) {
                    tallest = $(revenue).outerHeight();
                }
            });
            $revenues.css({
                "height": tallest + "px"
            });
        }

        function ceosReviewPieChartLayout() {
            var $pieChartWrapper = $(".pie-chart-wrapper");
            if (!$pieChartWrapper.length) {
                return;
            }
            var $textWrapper = $(".pie-chart-wrapper .content-wrapper .text-wrapper");
            if (windowWidth < 1366) {
                $textWrapper.css({
                    "height": "auto"
                });
                return;
            }
            var pieChartHeight = $(".pie-chart-wrapper .image-wrapper svg").height();
            $textWrapper.css({
                "height": pieChartHeight + "px"
            });
        }

        function playVideo() {
            var $video = $(".video-container video");
            if (!$video.length) {
                return;
            }
            var $videoPoster = $(".video-container .poster");
            var $videoBehind;
            $videoPoster.each(function (ignore, poster) {
                $(poster).on("click", function () {
                    $videoBehind = $(poster).closest(".video-container").find("video");
                    $videoBehind.trigger("click");
                });
            });
            $video.each(function (ignore, video) {
                $(video).on("click", function () {
                    var $poster = $(video).closest(".video-container").find(".poster");
                    video.play();
                    if (!$poster.hasClass("hide")) {
                        $poster.addClass("hide");
                    }
                });
            });
        }

        function squarePerformanceBoxes() {
            if (!$(".performance_boxes.logos").length) {
                return;
            }
            var $performanceBoxes = $(".performance_boxes .performance_boxes_box");
            var boxWidth;
            if (windowWidth >= 640 || windowWidth <= 480) {
                $performanceBoxes.each(function (ignore, performanceBox) {
                    boxWidth = $(performanceBox).innerWidth();
                    $(performanceBox).css({
                        "height": boxWidth + "px"
                    });
                });
            } else {
                $performanceBoxes.css({
                    "height": "auto"
                });
            }
        }

        function equalHeightsWeGrowTogether() {
            if (!$(".we-grow-together").length) {
                return;
            }
            var $weGrowTogether = $(".we-grow-together");
            var $weGrowTogetherHeaders = $weGrowTogether.find("h3");
            var $weGrowTogetherSummaries = $weGrowTogether.find(".summary");
            var $weGrowTogetherArchers = $weGrowTogether.find(".archer");
            $weGrowTogetherHeaders.css({
                "height": "auto"
            });
            $weGrowTogetherSummaries.css({
                "height": "auto"
            });
            $weGrowTogetherArchers.css({
                "height": "auto"
            });
            if (windowWidth < 1024) {
                return;
            }
            var tallest = 0;
            $weGrowTogetherHeaders.each(function (ignore, weGrowTogetherHeaders) {
                if ($(weGrowTogetherHeaders).height() > tallest) {
                    tallest = $(weGrowTogetherHeaders).height();
                }
            });
            $weGrowTogetherHeaders.css({
                "height": tallest + "px"
            });
            tallest = 0;
            $weGrowTogetherSummaries.each(function (ignore, weGrowTogetherSummary) {
                if ($(weGrowTogetherSummary).height() > tallest) {
                    tallest = $(weGrowTogetherSummary).height();
                }
            });
            $weGrowTogetherSummaries.css({
                "height": tallest + "px"
            });
            tallest = 0;
            $weGrowTogetherArchers.each(function (ignore, weGrowTogetherArcher) {
                if ($(weGrowTogetherArcher).height() > tallest) {
                    tallest = $(weGrowTogetherArcher).height();
                }
            });
            $weGrowTogetherArchers.css({
                "height": tallest + "px"
            });
        }

        events.add(window, "scroll", functions.debounce(function () {
            animate();
            triggerMenu();
            resetScrollToSection();
        }, 100));

        events.add(window, "resize", functions.debounce(function () {
            measureWindow();
            setHeightOfIntroSection();
            ceosReviewPieChartLayout();
            equalHeightsGrouRevenues();
            squarePerformanceBoxes();
            equalHeightsWeGrowTogether();
        }, 100));

        events.add(window, "orientationchange", function () {
            $("nav").css({
                "transition-duration": "0s"
            });
            measureWindow();
            setHeightOfIntroSection();
            ceosReviewPieChartLayout();
            window.setTimeout(function () {
                $("nav").css({
                    "transition-duration": "0.5s"
                });
            }, 501);
        });

        measureWindow();
        setHeightOfIntroSection();
        highlightNavItem();
        toggleMenu();
        wrapWords();
        animate();
        openHighlightBox();
        closeHighlightBoxes();
        if ($("body").is("#strategic-agenda-page")) {
            subnavLinks();
            setHashLocationSubnav();
        }
        if ($("body").is("#stakeholder-stories-page")) {
            stakeholderSubnavDetection();
        }
        scrollToSection();
        openShare();
        closeShare();
        equalHeightsGrouRevenues();
        ceosReviewPieChartLayout();
        playVideo();
        squarePerformanceBoxes();
        equalHeightsWeGrowTogether();
    });

    events.once(window, "load", function () {

        $("body").addClass("loaded");

    });


}(jQuery));
